module.exports = __webpack_public_path__ + "img/endocitosis.5f0c6f22.png";